import { apiClient } from "./httpClient";

export interface BenefitPayload {
  id?: string;
  description: string;
}

export const benefitsService = {
  create: async (benefit: BenefitPayload) => {
    const response = await apiClient.post(`/Benefits`, benefit);
    return response.data;
  },
  update: async (benefit: BenefitPayload) => {
    const response = await apiClient.put(`/Benefits/${benefit.id}`, benefit);
    return response.data;
  },
  delete: async (id: string) => {
    const response = await apiClient.delete(`/Benefits/${id}`);
    return response.data;
  },
  getAll: async () => {
    const response = await apiClient.get(`/Benefits`);
    // Endpoint paginado devolve PagedResult ({ items, ... }); a tela espera o array.
    return response.data?.items ?? (Array.isArray(response.data) ? response.data : []);
  },
};
